import { render, staticRenderFns } from "./network-statistics.vue?vue&type=template&id=88884570&scoped=true&"
import script from "./network-statistics.vue?vue&type=script&lang=ts&"
export * from "./network-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./network-statistics.vue?vue&type=style&index=0&id=88884570&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88884570",
  null
  
)

export default component.exports